import moment from "moment";

import { formatBRL } from "../../monitoramento-preco/components/mpUtils";

export const TIPO_COLETA = {
  padrao: "Padrão",
  direcionada: "Direcionada",
};

export default function mapColetaTableRow(coleta) {
  return {
    idColeta: coleta.idColeta,
    dataEnvioFormat: moment
      .utc(coleta.dataEnvioUtc)
      .local()
      .format("DD/MM/YYYY"),
    dataEnvioUtc: coleta.dataEnvioUtc,
    dataColeta: coleta.dataColeta.replaceAll("-", "/"),
    lojaRazaoSocial: coleta.loja?.razaoSocial || "—",
    lojaGrupoEconomico: coleta.loja?.grupoEconomico || "—",
    representante: coleta.representante || "—",
    sku: coleta.produto?.sku || "—",
    produtoNome: coleta.produto?.nome || "—",
    marca: coleta.produto?.marca ?? "",
    precoMarcaFormat: formatBRL(
      coleta.precoMarcaLoja ?? coleta.precoKarstenLoja,
    ),
    precoMarcaLoja: coleta.precoMarcaLoja ?? coleta.precoKarstenLoja,
    tipoColeta: TIPO_COLETA[coleta.tipoColeta] || "—",
    qtdConcorrentes: coleta.concorrentes?.length ?? 0,
    detalhe: coleta,
  };
}
